import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, IntlProvider } from '@godaddy/react-mintl';
import { useRootProps, UserDataProvider } from '../../header/src/components/UserDataProvider';
import { TYPES } from '../../header/src/lib/types';

import './footer.css';

/**
 * Investor footer component
 * @param {Object} props Props
 * @param {number} props.privateLabelId Private Label ID
 * @returns {React.ReactElement} React element for investor footer
 */
function InvestorFooter({ privateLabelId }) {

  if ([497036, 1001836].includes(privateLabelId)) {
    const footerOptions = {
      copyright: <FormattedMessage id='InvestorFooter:Copyright' values={{ year: new Date().getFullYear() }} />,
      privacyHref: 'https://www.afternic.com/legal/agreements/privacy-policy',
      cookieHref: 'https://www.afternic.com/legal/agreements/cookie-policy'
    };
    return (
      <div className='investor-footer'>
        <div>{ footerOptions.copyright }</div>
        <div>
          <a href={ footerOptions.privacyHref } className='privacy-policy'>
            <FormattedMessage id='Footer:PrivacyPolicy' />
          </a>
          &nbsp;&nbsp;
          <a href={ footerOptions.cookieHref } className='do-not-sell'>
            <FormattedMessage id='Privacy:DoNotShare' />
          </a>
        </div>
      </div>
    );
  }
  return null;
}

InvestorFooter.propTypes = {
  privateLabelId: PropTypes.number,
  urls: PropTypes.shape({
    privacy: PropTypes.shape({
      href: PropTypes.string
    }),
    cookies: PropTypes.shape({
      href: PropTypes.string
    })
  })
};

export function Footer() {
  const { requestedHeader, privateLabelId } = useRootProps();

  return (
    <div className='footer-center'>
      {requestedHeader === TYPES.investors && <InvestorFooter privateLabelId={ privateLabelId } />}
    </div>
  );
}

Footer.propTypes = {
  requestedHeader: PropTypes.string,
  supportContacts: PropTypes.shape({
    technicalSupportDescription: PropTypes.string,
    technicalSupportPhone: PropTypes.string
  })
};

const FooterWrapper = (props) => {
  return (
    <UserDataProvider { ...props }>
      <IntlProvider locale={ props.market } messages={ props.messages }>
        <Footer { ...props } />
      </IntlProvider>
    </UserDataProvider>
  );
};

FooterWrapper.propTypes = {
  market: PropTypes.string,
  messages: PropTypes.object
};

export default FooterWrapper;
